import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
  bulkCreateEmailInvitation,
  bulkDeleteEmailInvitation,
  getEmailInvitationList,
  sendEmailInvitation,
} from '../../api/constlink';
import PartnerInvitationListComponent from '../../components/partners/PartnerInvitationListComponent';
import { EmailInvitation, EmailInvitationType } from '../../modules/auth';
import { Modal, Spin } from 'antd';

interface PartnerInvitationListContainerProps {
  enterpriseId: string;
}

function PartnerInvitationListContainer({
  match,
}: RouteComponentProps<PartnerInvitationListContainerProps>) {
  const { enterpriseId } = match.params;
  const [loading, setLoading] = useState(false);
  const [partnerInvitations, setPartnerInvitations] =
    useState<EmailInvitation[]>();
  useEffect(() => {
    (async () => {
      setLoading(true);
      const res: any = await getEmailInvitationList({
        enterpriseId,
        type: EmailInvitationType.PARTNER,
      });
      setPartnerInvitations(res);
      setLoading(false);
    })();
  }, [enterpriseId]);

  const _sendEmailInvitation = async (selectedValues: number[]) => {
    setLoading(true);
    const emailInvitations = await sendEmailInvitation({
      enterpriseId,
      idList: selectedValues,
    });
    setPartnerInvitations(emailInvitations);
    setLoading(false);
    Modal.success({ content: '이메일/문자 발송이 완료 되었습니다.' });
  };

  const _bulkCreateEmailInvitation = async (dto: any) => {
    setLoading(true);
    const emailInvitations = await bulkCreateEmailInvitation({
      enterpriseId,
      dto,
    });
    setPartnerInvitations(emailInvitations);
    setLoading(false);
    Modal.success({ content: '정상적으로 업로드 되었습니다.' });
  };

  const _deleteEmailInvitations = async (selectedValues: number[]) => {
    setLoading(true);
    const emailInvitations = await bulkDeleteEmailInvitation({
      enterpriseId,
      idList: selectedValues,
    });
    setPartnerInvitations(emailInvitations);
    setLoading(false);
    Modal.success({ content: '거래처 초대 요청이 삭제 되었습니다.' });
  };

  return (
    <>
      {loading && <Spin />}
      {partnerInvitations && (
        <PartnerInvitationListComponent
          partnerInvitations={partnerInvitations}
          sendEmailInvitation={_sendEmailInvitation}
          bulkCreateEmailInvitation={_bulkCreateEmailInvitation}
          deleteEmailInvitations={_deleteEmailInvitations}
        />
      )}
    </>
  );
}

export default PartnerInvitationListContainer;
